var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'BUSSTOP')?[_c('docomo-busstop-marker')]:(_vm.type == 'POSITION')?[_c('docomo-position-marker')]:_vm._e(),_c('docomo-car-marker'),_c('docomo-current-marker')],2)}
var staticRenderFns = []

export { render, staticRenderFns }